/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, type InputHTMLAttributes } from "react";
import { RiSearchLine } from "react-icons/ri";
import { MdClear } from "react-icons/md";
import { Loading } from "../../Loading";
import * as Styles from "./textInput.styles";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  onSearch?: () => void;
  onClear?: () => void;
  value?: string;
  disabled?: boolean;
  maxLength?: number;
  mandatory?: boolean;
  searchIcon?: "left" | "right";
  isLoading?: boolean;
  focus?: boolean;
  incite?: boolean;
  button?: boolean;
}

export const Searchbar: React.FC<Props> = ({
  placeholder,
  onSearch,
  onClear,
  value,
  disabled,
  maxLength,
  mandatory,
  searchIcon,
  isLoading,
  focus,
  incite,
  button,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onHandleFocus = (val: boolean) => {
    if (focus) setIsFocused(val);
  };

  return (
    <Styles.Container>
      <Styles.ContainerInput
        disabled={disabled}
        isFocused={isFocused}
        searchIcon={searchIcon}
        incite={incite}
        button={button}
      >
        {searchIcon !== "right" &&
          (isLoading ? (
            <Loading size={14} fit />
          ) : (
            <div
              className={button ? "button-icon" : ""}
              onClick={button ? onSearch : undefined}
            >
              <RiSearchLine
                className={"search-icon"}
                color={isFocused ? "#333" : button ? "white" : "#A3A3A6"}
                size={20}
                style={{
                  cursor: button ? "pointer" : onSearch ? "pointer" : "auto",
                }}
                onClick={button ? undefined : onSearch}
              />
            </div>
          ))}
        <Styles.Input
          type="text"
          {...rest}
          value={value}
          maxLength={maxLength}
          onFocus={() => {
            onHandleFocus(true);
          }}
          onBlur={() => {
            onHandleFocus(false);
          }}
          disabled={disabled}
          placeholder={placeholder}
        />
        {searchIcon === "right" &&
          (isLoading ? (
            <Loading size={14} fit />
          ) : (
            <>
              {onClear && value && value?.trim()?.length > 0 && (
                <div className="button-clear" onClick={onClear}>
                  <MdClear size={22} color="#A3A3A6" onClick={onClear} />
                </div>
              )}
              <div
                className={button ? "button-icon" : ""}
                onClick={button ? onSearch : undefined}
              >
                <RiSearchLine
                  className={"search-icon"}
                  color={isFocused ? "#333" : button ? "white" : "#A3A3A6"}
                  size={20}
                  style={{
                    cursor: button ? "pointer" : onSearch ? "pointer" : "auto",
                  }}
                  onClick={button ? undefined : onSearch}
                />
              </div>
            </>
          ))}
        {searchIcon !== "right" &&
          !!onClear &&
          value &&
          value?.trim()?.length > 0 && (
            <div className="button-clear" onClick={onClear}>
              <MdClear size={22} color="#A3A3A6" onClick={onClear} />
            </div>
          )}
      </Styles.ContainerInput>
    </Styles.Container>
  );
};

Searchbar.defaultProps = {
  placeholder: "Pesquisar",
  disabled: false,
  maxLength: 10000,
  mandatory: false,
};
